export const TABLE_ROW_HEIGHT = 42
